

const Spinner = ({ style }) => {

    const myStyle = {
        ...style,
        justifyContent: "center"
    };

    return <div className="d-flex" style={myStyle}><div className="loading-container">
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    </div>
    </div>;
};

export default Spinner;